import React from "react";
import AppLink from "components/common/style/link/AppLink";
import { PhotoInfo } from "model/photo_series/PhotoInfo";
import { PHOTO_SIZE_TYPE } from "constant/photo_series/photo_series.constant";
import styled from "styled-components";

type SeriesPhotoFileLinkProps = {
  fileName: PhotoInfo;
  foldName: string;
};

const SeriesPhotoFileLink = ({
  fileName,
  foldName,
}: SeriesPhotoFileLinkProps) => {
  return (
    <>
      {foldName ? (
        <ImDiv>
          <AppLink
            to={fileName.getPhotoStaticUrl(foldName, PHOTO_SIZE_TYPE.LARGE)}
            target="_blank"
          >
            <Img
              src={fileName.getPhotoStaticUrl(foldName, PHOTO_SIZE_TYPE.SMALL)}
              alt={fileName.getAlt()}
            />
          </AppLink>
        </ImDiv>
      ) : (
        <span>{fileName.name}</span>
      )}
    </>
  );
};

const ImDiv = styled.div`
  display: flex;
  width: 100px;
  height: 100px;
  align-items: center;
  justify-content: center;
`;

const Img = styled.img`
  max-width: 100px;
  max-height: 100px;
`;

export default SeriesPhotoFileLink;
